<div class="modal1Main defaultPop">
    <div class="modalHeader">
      <span class="title">
          Assign Default Ranking ?
      </span>
      <button class="closepop float-right" mat-dialog-close><i class="zmdi zmdi-close"></i></button>
    </div>
  
    <div class="defaultPopCont">
        <p>Are you sure want to assign default ranking?</p>
    </div>
  
    <div class="text-right defaultPopfoot">
        <button mat-raised-button color="primary" class="cancelBtn" mat-dialog-close>Cancel</button>
        <button mat-raised-button color="primary" class="joinDraftBtn" (click)="resetDefaultRanking()">Ok</button> 
    </div>
</div> 
  